import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CreditsTicker } from "./CreditsTicker";

const POSTER =
  "https://static.prod-images.emergentagent.com/jobs/f8435c69-857e-497d-b480-eeab9bfacf99/images/fdf91905f6b3b9c46bb4021e1fa46202c54108c191f2328d7aff899e971bf0cb.png";

const VIDEO_SOURCES = [
  "https://videos.pexels.com/video-files/3045163/3045163-hd_1920_1080_24fps.mp4",
  "https://videos.pexels.com/video-files/4754030/4754030-uhd_2560_1440_25fps.mp4",
];

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate flex min-h-[100svh] w-full flex-col justify-end overflow-hidden bg-loudar-ink pt-24 md:pt-28"
    >
      <div className="absolute inset-0 -z-10">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={POSTER}
          className="h-full w-full object-cover"
          data-testid="hero-video"
        >
          {VIDEO_SOURCES.map((src) => (
            <source key={src} src={src} type="video/mp4" />
          ))}
        </video>
        <div className="absolute inset-0 bg-loudar-ink/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-loudar-ink/40 via-loudar-ink/55 to-loudar-ink" />
      </div>

      <div className="container-loudar relative z-10 flex flex-1 flex-col justify-center pb-14 md:pb-24">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.05, ease: [0.2, 0.8, 0.2, 1] }}
          className="font-display uppercase leading-[0.86] tracking-tight text-white text-[44px] sm:text-[68px] md:text-[96px] lg:text-[120px]"
          data-testid="hero-headline"
        >
          Your Reputation
          <br />
          <span className="text-stroke">In Music,</span>{" "}
          <span className="text-loudar-orange">Finally Organised.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-7 max-w-2xl text-base text-white/70 md:text-lg"
          data-testid="hero-subtitle"
        >
          Loudar helps artists, producers, engineers, DJs, managers, writers, and crew
          build professionally represented identities — backed by verified collaborations,
          trusted reviews, and real industry experience.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.28 }}
          className="mt-5 max-w-2xl font-display text-xl uppercase leading-snug tracking-tight text-white sm:text-2xl"
          data-testid="hero-promise"
        >
          LOUDAR helps you build your network and open doors that were once{" "}
          <span className="text-loudar-orange">out of reach.</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-9 flex flex-wrap items-center gap-4"
        >
          <Link to="/pilot" className="btn-primary" data-testid="hero-cta-apply">
            Join the waiting list <ArrowRight size={16} />
          </Link>
        </motion.div>
      </div>

      <div className="relative z-10 border-y border-white/[0.06] bg-black/30 backdrop-blur-sm py-3">
        <CreditsTicker />
      </div>
    </section>
  );
};

export default Hero;
